import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import { Card, FormGroup, Alert } from "reactstrap";
import Box from '@mui/material/Box';

// import Typography from "@mui/material/Typography";
import Collapse from '@mui/material/Collapse';
import { viewKycDetails } from "../../redux/actions/viewKycDetailsAction";

import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import {
	resetGetCustomerDetails,
	getCustomerDetails
} from "../../redux/actions/getCustomerDetailsAction";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import GetAppIcon from '@mui/icons-material/GetApp'
import {
	Button,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails,Typography
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";

import { ExpandMore } from "@mui/icons-material";
import {
	resetgetKybApproveReject,
	getKybApproveRejectReq
} from "../../redux/actions/getKybApproveRejectAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import ClearIcon from "@mui/icons-material/Clear";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { getKycApproveRejects } from "../../redux/actions/getKycApproveRejectAction";
const useRowStyles = makeStyles({
	root: {
		"& > *": {
			// borderBottom: "unset",
		}
	}
});

function AdminViewKycDetails() {
	const location = useLocation();

	const [open, setOpen] = React.useState(false);
	const [viewKycDetailsStatus, setViewKycDetailsStatus] = useState(false);
	const [viewKycDetailsArray, setViewKycDetailsArray] = useState([]);

	const classes = useRowStyles();
	const verificationId = location.state.param1;
	const customerId = location.state.param2;
	console.log(customerId);
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const viewKycDetailsRes = useSelector(({ viewKycDetails }) => viewKycDetails);

	// const viewKycDetailsRes = useSelector(
	// 	({ getCustomerDetails }) => getCustomerDetails
	// );

	const setViewKycDetailsStatusFunc = () => {
		setViewKycDetailsStatus(true);
		let req = {
			loginDetails: {
				walletOwnerId: "1"
			},
			actionCustomerMasterRequestVO: {
				verificationId: verificationId,
				customerId: customerId
			}
		};

		return dispatch(viewKycDetails(req, authToken));
	};

	useEffect(() => {
		setViewKycDetailsStatusFunc();
	}, [customerId]);

	console.log(viewKycDetailsRes, "viewKycDetailsRes");

	const viewKycDetailsStatusFunc = () => {
		if (viewKycDetailsStatus) {
			if (viewKycDetailsRes.data.status == "success") {
				setViewKycDetailsArray(viewKycDetailsRes.data);
			}
			if (viewKycDetailsRes.data.status == "failed") {
				setViewKycDetailsArray(viewKycDetailsRes.data);
				if (
					viewKycDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					viewKycDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		viewKycDetailsStatusFunc();
	}, [viewKycDetailsRes.data.status]);

	// const handleAcceptOrRejectReq = (
	// 	customerId,
	// 	role,
	// 	companyId,
	// 	recommendation
	// ) => {

	// 	setgetKybApprovedorRejectStatus(true);
	// 	const acceptOrRejectReq = {
	// 		actionCustomerMasterRequestVO: {
	// 			walletOwnerId: "1",
	// 			customerId: customerId,
	// 			role: role,
	// 			userName: "mtransact",
	// 			companyId: companyId,
	// 			recommendation: recommendation
	// 		}
	// 	};
	// 	return dispatch(getKybApproveRejectReq(acceptOrRejectReq, authToken));
	// };

	const handleAcceptOrRejectReq = (
		recommendation, action, customerid, personid, verificationid
	) => {
		const acceptOrRejectReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId
			},
			actionCustomerMasterRequestVO: {
				recommendation: recommendation,
				action: action,
				customerId: customerid,
				personId: personid,
				regFraudId: verificationid
			}
		};
		dispatch( getKycApproveRejects( acceptOrRejectReq, authToken ) )
	}

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: ""
					}}
				>
					<div style={{ marginBottom: "1.5rem" }}>
						<Alert
							className="text-center tableHeaderColor"
							variant="secondary"
							// fullWidth={true}
							// style={{ backgroundColor: "#00b9f5", borderRadius: "0" }}
						>
							<Typography variant="body1">KYC Details</Typography>
						</Alert>
					</div>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<div style={{ marginTop: '2rem' }}>
							<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className='themeText'>
									Registration Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<Row
									style={{
										margin: "0"
									}}
								>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Parent ID:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.customerId) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Role:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.userRole) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Entity Type:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.entityType) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Created By:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.initiatedBy) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Modified By:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.initiatedBy) ||
													"-"}
											</Col>
										</Row>
									</Col>
								</Row>
							</AccordionDetails>
						</Accordion>
						</div>

						<div style={{ marginTop: '2rem' }}>
							<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className='themeText'>
									Verification Registration Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<div
									style={{
										padding: "0 14px"
									}}
								>
									{/* <h3 style={{ marginTop: "4rem", marginLeft: "1rem" }}>
                            {/* KYC Details */}
									{/* </h3> */}

									<Row className="detail-info row">
										<Col md={6}>Action</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.action &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.action)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verification ID</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.verificationId &&
											[]
												.concat(
													viewKycDetailsArray.kycDetailList.verificationId
												)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Request ID</Col>

										{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
											viewKycDetailsArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.requestId}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Request status</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.regStatus &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.regStatus)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Request Date</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.regDate &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.regDate)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Response ID</Col>

										{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
											viewKycDetailsArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.responseId}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verification status</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.verifyStatus &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.verifyStatus)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verification Description</Col>

										{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
											viewKycDetailsArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.description}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verification Type</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.docCheckType &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.docCheckType)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Score</Col>

										{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
											viewKycDetailsArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.fraudScore}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Recommendation</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.recommendation &&
											[]
												.concat(
													viewKycDetailsArray.kycDetailList.recommendation
												)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Confidence Level</Col>

										{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
											viewKycDetailsArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.confidenceLevel}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verified On</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.customerRegDate &&
											[]
												.concat(
													viewKycDetailsArray.kycDetailList.customerRegDate
												)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
									<hr />
									<Row className="detail-info row">
										<Col md={6}>Verified By</Col>

										{(viewKycDetailsArray.kycDetailList &&
											viewKycDetailsArray.kycDetailList.verifiedBy &&
											[]
												.concat(viewKycDetailsArray.kycDetailList.verifiedBy)
												.map((detail, i) => {
													return <Col md={4}>{detail}</Col>;
												})) || <Col md={4}>-</Col>}
									</Row>
								</div>
							</AccordionDetails>
						</Accordion>
						</div>

						<div style={{ marginTop: '2rem' }}>
							<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className='themeText'>
									Personal Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<Row
									style={{
										margin: "0"
									}}
								>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Person ID:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.kycDetailList &&
													viewKycDetailsArray.kycDetailList.personId) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>First Name:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.firstName) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Last Name:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.lastName) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Email Id:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.customerEmail) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Date Of Birth:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.dob) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Phone no:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.mobile) ||
													"-"}
											</Col>
										</Row>
									</Col>
								</Row>
							</AccordionDetails>
						</Accordion>
						</div>

						<div style={{ marginTop: '2rem' }}>
							<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className='themeText'>
									Address Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<Row
									style={{
										margin: "0"
									}}
								>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Address:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.customerId) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>State:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.userRole) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>City:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.entityType) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Zip:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.initiatedBy) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Country Code:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.customerMasterDetailsResponseVO &&
													viewKycDetailsArray.customerMasterDetailsResponseVO
														.initiatedBy) ||
													"-"}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Customer Ip Address:</Col>
											<Col md={6}>
												{(viewKycDetailsArray.list &&
													viewKycDetailsArray.list.ipAddress) ||
													"-"}
											</Col>
										</Row>
									</Col>
								</Row>
							</AccordionDetails>
						</Accordion>
						</div>

						<div style={{ marginTop: '2rem' }}>
							<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography className='themeText'>
									Document Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<Col md={12}>
									<Row className="detail-info row">
										<Col md={6}>File Name:</Col>
										<Col md={6}>
											{viewKycDetailsArray.operationList &&
											viewKycDetailsArray.operationList.fileName
												? viewKycDetailsArray.operationList &&
												  viewKycDetailsArray.operationList.fileName
												: "-"}
										</Col>
									</Row>
									<hr />
									{viewKycDetailsArray.operationList &&
										viewKycDetailsArray.operationList &&
										[].concat(viewKycDetailsArray.operationList).map((img) => (
											<>
												<Row
													className="detail-info row"
													style={{ marginBottom: "2rem" }}
												>
													<Col md={4}>File Image:</Col>
													<Col md={4}>
														<img
															src={`data:image/jpeg;base64,${img.fileImage}`}
															style={{ maxWidth: "100%" }}
														/>
														<br />
														<br />
														<h6>{img.fileName}</h6>
													</Col>
													<Col md={4}>
														<a
															download={img.fileName}
															href={`data:image/jpeg;base64,${img.fileImage}`}
														>
															<GetAppIcon />
														</a>
													</Col>
												</Row>
												<hr />
											</>
										))}
									<br />
								</Col>
							</AccordionDetails>
						</Accordion>
						</div>
						{viewKycDetailsRes.data.kycDetailList &&
							viewKycDetailsRes.data.kycDetailList.verifyStatus == "Approve" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
							{
								viewKycDetailsRes.data.kycDetailList && 
								viewKycDetailsRes.data.kycDetailList.verifyStatus == "Reject" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											disabled
											style={{
												padding: "8px"
											}}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
							{
								viewKycDetailsRes.data.kycDetailList &&
								viewKycDetailsRes.data.kycDetailList.verifyStatus == "Pending" && (
								<Row className="detail-info row">
									<Col
										md={12}
										style={{ textAlign: "center", marginTop: "1rem" }}
									>
										<CustomButton
											style={{
												padding: "8px"
											}}
											onClick={() =>
												handleAcceptOrRejectReq(
													"Approve",
													viewKycDetailsRes.data.kycDetailList.action,
													viewKycDetailsRes.data.kycDetailList.customerId,
													viewKycDetailsRes.data.kycDetailList.personId,
													viewKycDetailsRes.data.kycDetailList.verificationId,
												)
											}
										>
											Approve <ThumbUpIcon />
										</CustomButton>
										<CustomButton
											style={{
												padding: "8px"
											}}
											onClick={() =>
												handleAcceptOrRejectReq(
													"Reject",
													viewKycDetailsRes.data.kycDetailList.action,
													viewKycDetailsRes.data.kycDetailList.customerId,
													viewKycDetailsRes.data.kycDetailList.personId,
													viewKycDetailsRes.data.kycDetailList.verificationId,
												)
											}
										>
											Reject <ClearIcon />
										</CustomButton>
									</Col>
								</Row>
							)}
						{/* <div style={{ textAlign: "center", margin: "40px 0" }}>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								endIcon={<ThumbUpAltRoundedIcon />}
								variant="contained"
								// onClick={handleAcceptOrRejectReq}
							>
								Approve
							</Button>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								endIcon={<ClearRoundedIcon />}
								variant="contained"
								// onClick={handleAcceptOrRejectReq}
							>
								Reject
							</Button>
						</div> */}
					</Box>
				</div>
			</Layout>
		</>
	);
}

export default AdminViewKycDetails;
